(function ( $ ) {

    $(function () {
        $('.search-toggle').click( function () {
            $('.search-wrap').slideToggle();
        });
    })

})( jQuery );